export default "/_next/static/ac81f478f97c4b6111e9b9efece84a85.png";